module.exports = __webpack_public_path__ + "static/img/CH.c77b19ef.png";